if ('NodeList' in window && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = function (callback, thisArg) {
    thisArg = thisArg || window;
    for (var i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this);
    }
  };
}

/*
  Automatically instantiates modules based on data-attributes
  specifying module file-names.
*/

const moduleElements = document.querySelectorAll('[data-module]');

for (var i = 0; i < moduleElements.length; i++) {
  const el = moduleElements[i];
  const name = el.getAttribute('data-module');
  const Module = require(`./${name}`).default;
  new Module(el);
}

/*
  Usage:
  ======
  html
  ----
  <button data-module="disappear">disappear!</button>
  js
  --
  // modules/disappear.js
  export default class Disappear {
    constructor(el) {
      el.style.display = 'none'
    }
  }
*/

/*
  Override Bootstrap default setting of 1 accordion item open at a time
*/
const accordions = document.querySelectorAll('.panel-collapse');

accordions.forEach(function (item) {
  item.removeAttribute('data-parent');
});



// WEBPACK FOOTER //
// ./scripts/modules/index.js